import {defineMessages} from 'react-intl';

export default defineMessages({
	remember: {
		id: 'auth.login.remember',
		defaultMessage: 'Remember me',
	},
});
